import React from 'react';
import { To } from 'react-router-dom';
import { Paths } from 'shared/routes';

export enum MainNavigationItemId {
  Todo = 'todo',
  Inbox = 'inbox',
  Today = 'today',
  Upcoming = 'upcoming',
  AllTasks = 'all-tasks',
  Completed = 'completed',
  MyLife = 'my-life',
  LifeAreas = 'life-areas',
  Goals = 'goals',
  GoalsCalendar = 'goals-calendar',
  Habits = 'habits',
  Journal = 'journal',
  Insights = 'insights',
}

export type SubNavigationItem = {
  id: MainNavigationItemId;
  translationLabel: string;
  link?: To;
  pathsToMatch?: Paths[];
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  comingSoon?: boolean;
};

export type NavigationItem = {
  id: MainNavigationItemId;
  translationLabel: string;
  link?: To;
  pathsToMatch?: Paths[];
  subItems: SubNavigationItem[];
};

export type MobileNavigationItem = {
  id: MainNavigationItemId;
  translationLabel: string;
  link: To;
  pathsToMatch: Paths[];
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
};
